// extracted by mini-css-extract-plugin
export default {"photo_list":"Home_photo_list__5Bi2c","grid_container":"Home_grid_container__CUQ2U","grid_item":"Home_grid_item__ENbWq","Image":"Home_Image__GDdMh","title":"Home_title__B6Jyb"};